/** @jsx jsx */
import React, { PropsWithChildren } from 'react';
import { jsx } from '@balance-web/core';

import { ReckonBalanceCore } from '@reckon-web/reckon-balance-core';

import { ClipboardProvider } from '../../common/ClipboardButton';

/**
 * Configure the app theme here.
 */
export function BalanceProvider({ children }: PropsWithChildren<{}>) {
  return (
    <ReckonBalanceCore themeMode="light">
      <ClipboardProvider>{children}</ClipboardProvider>
    </ReckonBalanceCore>
  );
}
